import React, { useState } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import { ReactComponent as MenuIconWhite } from '../../../assets/icons/MenuDots.svg';
import { ReactComponent as MenuIconBlack } from '../../../assets/icons/MenuDotsB.svg';
import { ReactComponent as PenIcon } from '../../../assets/icons/Pen.svg';
import { NoteResponse } from '../../../api/notes';
import { formatUKDate } from '../../../utils';
import viewIcon from '../../../assets/icons/eye.svg';
import './ReferralLetter.scss';
import downloadIcon from '../../../assets/icons/download.svg';

type Props = {
  noteData: NoteResponse;
  onViewNote: (note: NoteResponse, forceViewOnly?: boolean) => void;
  onEditNote: (note: NoteResponse) => void;
  onDeleteNote: (noteId: number) => void;
  isReadOnly?: boolean;
  onRequestDownload: (note: NoteResponse) => void;
};

const stripHtml = (html: string) => {
  const tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
};

const ReferralLetterRow: React.FC<Props> = ({
  noteData,
  onViewNote,
  onEditNote,
  onDeleteNote,
  isReadOnly = false,
  onRequestDownload,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  const onOptionClick = (action: string) => {
    if (action === 'view') {
      onViewNote(noteData);
    } else if (action === 'edit') {
      onEditNote(noteData);
    } else if (action === 'delete') {
      onDeleteNote(noteData.id);
    }
    setIsMenuOpen(false);
  };

  const actionMenuStyles = {
    backgroundColor: isMenuOpen ? '#238698' : 'transparent',
  };

  const onMenuIconClick = (e: React.MouseEvent<any>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsMenuOpen((prev) => !prev);
  };

  return (
    <div className='table-row'>
      <div className='table-cell'>
        {noteData.created_at ? (
          <div>
            <div>{formatUKDate(noteData.created_at)}</div>
            <div>{formatUKDate(noteData.created_at, 'hh:mm a')}</div>
          </div>
        ) : (
          '-'
        )}
      </div>
      <div className='table-cell'>
        {noteData.updated_at ? (
          <div>
            <div>{formatUKDate(noteData.updated_at)}</div>
            <div>{formatUKDate(noteData.updated_at, 'hh:mm a')}</div>
          </div>
        ) : (
          '-'
        )}
      </div>
      <div className='table-cell note-content'>
        {noteData.title ? `${noteData.title}: ` : ''}
        {noteData.description ? stripHtml(noteData.description) : '-'}
      </div>
      <div className='table-cell'>
        {noteData.author ? `${noteData.author.first_name} ${noteData.author.last_name}` : '-'}
      </div>
      <div className='table-cell'>
        {noteData && (
          <>
            <button
              className='view-notes-button'
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onViewNote(noteData, true);
              }}
            >
              <img src={viewIcon} alt='View' />
            </button>
            <button
              className='view-notes-button'
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onRequestDownload(noteData);
              }}
            >
              <img src={downloadIcon} alt='Download' />
            </button>
          </>
        )}
      </div>
      <div className='table-cell actions'>
        {!isReadOnly && (
          <OutsideClickHandler onOutsideClick={() => setIsMenuOpen(false)}>
            <div className='action-menu-container'>
              <div className='menu-btn' style={actionMenuStyles}>
                {isMenuOpen ? (
                  <MenuIconWhite onClick={(e) => onMenuIconClick(e)} />
                ) : (
                  <MenuIconBlack onClick={(e) => onMenuIconClick(e)} />
                )}
              </div>
              {isMenuOpen && (
                <div className='action-menu'>
                  <div
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      onOptionClick('view');
                    }}
                    className='option'
                  >
                    <PenIcon />
                    Edit
                  </div>
                </div>
              )}
            </div>
          </OutsideClickHandler>
        )}
      </div>
    </div>
  );
};

export default ReferralLetterRow;
